import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import AdSense from "./AdSense";

function Page(props) {
  return (
    <React.Fragment>
      <Header />
      <main className="page__content">
        <article>
          <AdSense />
          {props.children}
        </article>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export default Page;
